// extracted by css-extract-rspack-plugin
export default {"row":"index__row___Vdg5i","column":"index__column___DDo47"};